/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sheet_TitleInputs */

const en_us2_offline_sheet_title = /** @type {(inputs: Offline_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not synced`)
};

const pt_br2_offline_sheet_title = /** @type {(inputs: Offline_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não sincronizado`)
};

const es_419_offline_sheet_title = /** @type {(inputs: Offline_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin sincronizar`)
};

const pt_pt2_offline_sheet_title = /** @type {(inputs: Offline_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não sincronizado`)
};

const fr_fr2_offline_sheet_title = /** @type {(inputs: Offline_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non synchronisé`)
};

const de_de2_offline_sheet_title = /** @type {(inputs: Offline_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht synchronisiert`)
};

const it_it2_offline_sheet_title = /** @type {(inputs: Offline_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sincronizzato`)
};

/**
* | output |
* | --- |
* | "Not synced" |
*
* @param {Offline_Sheet_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_sheet_title = /** @type {((inputs?: Offline_Sheet_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sheet_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_sheet_title(inputs)
	if (locale === "es-419") return es_419_offline_sheet_title(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sheet_title(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_sheet_title(inputs)
	if (locale === "de-DE") return de_de2_offline_sheet_title(inputs)
	if (locale === "it-IT") return it_it2_offline_sheet_title(inputs)
	return en_us2_offline_sheet_title(inputs)
});
export { offline_sheet_title as "offline.sheet_title" }